export default __webpack_public_path__ + "static/media/glyph_down_black_icon.ab4786f8.svg";